package com.milta.feature.importjobs.domain.entity

/**
 * Retour 26/10 — real step of a running import, as reported by the server: [Reading] (the AI reads
 * the document) then [Geocoding] (addresses checked one by one). Null while the job is Pending.
 */
enum class ImportJobStage {
    Reading,
    Geocoding,
    ;

    companion object {
        /** An unknown value (newer server) is treated as no step, never a decoding failure. */
        fun fromApi(value: String?): ImportJobStage? = entries.firstOrNull { it.name == value }
    }
}
